"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon"));
var Button_1 = require("../Button/Button");
require("./Box.css");
var Box = function (props) {
    var collapsed = props.collapsed, header = props.header, children = props.children, borderless = props.borderless, className = props.className, collapsible = props.collapsible, defaultCollapsed = props.defaultCollapsed, onToggle = props.onToggle;
    var _a = React.useState(defaultCollapsed || false), isCollapsed = _a[0], setIsCollapsed = _a[1];
    var shouldCollapse = 'collapsed' in props ? collapsed : isCollapsed;
    function handleToggleCollapse() {
        if (onToggle) {
            onToggle(!isCollapsed);
        }
        setIsCollapsed(!isCollapsed);
    }
    return (React.createElement("div", { className: (0, classnames_1.default)('dcl box', className, { borderless: borderless }) },
        header && (React.createElement("div", { className: (0, classnames_1.default)('box-header', { collapsed: shouldCollapse }), role: collapsible ? 'button' : '', onClick: collapsible ? handleToggleCollapse : undefined },
            React.createElement("div", { className: "dcl box-header-text" }, header),
            collapsible && (React.createElement(Button_1.Button, { basic: true, className: "collapse-btn", onClick: handleToggleCollapse },
                React.createElement(Icon_1.default, { name: shouldCollapse ? 'chevron down' : 'chevron up' }))))),
        !shouldCollapse && React.createElement("div", { className: 'dcl box-children' }, children)));
};
exports.Box = Box;
